import React, { useEffect } from "react";

import { styled } from "styled-components";
import { bp } from "../../../../../styles/breakPoints.tsx";
import IconClose from "../../../../../assets/images/icon-close.svg";
import { useTranslation } from "react-i18next";

const DialogElement = styled.dialog`
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  border: none;
  width: 100%;
  margin: auto;

  @media ${bp.md} {
    width: 90%;
    max-width: 1400px;
    padding: 20px 30px;
    max-height: 90%;
  }

  &::backdrop {
    background: rgba(0, 0, 0, 0.5);
  }

  .dialog-content {
    position: relative;
    padding-top: 36px;
  }

  .close-button {
    z-index: 10;
    border: none;
    padding: 8px;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    background: var(--Valo);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;

    &:hover {
      opacity: 0.7;
    }
  }
`;

function Dialog({ isVisible, onClose, children }: { isVisible: boolean, onClose: () => void, children: React.ReactNode }) {

  const { t } = useTranslation();

  const dialogRef = React.useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (isVisible) {
      dialog?.showModal();
    } else {
      dialog?.close();
    }

    // Close state sync when dialog is closed manually (e.g. Esc key)
    const handleDialogClose = () => onClose();
    dialog?.addEventListener('close', handleDialogClose);

    return () => {
      dialog?.removeEventListener('close', handleDialogClose);
    };

  }, [isVisible, onClose]);

  const handleBackdropClick = (e: React.MouseEvent<HTMLDialogElement>) => {
    if (e.target === dialogRef.current) {
      onClose();
    }
  };

  return (
    <>
      <DialogElement ref={dialogRef} className="dialog" onClick={handleBackdropClick}>
        <button type="button" className="close-button" onClick={onClose}>
          <img src={IconClose} alt={t('common.close')} />
        </button>
        <div className="dialog-content">{children}</div>
      </DialogElement>
    </>
  );
}

export default Dialog;
